import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ParamssubjectsSubjectIdArticlesUsingGet,
  SubjectVO,
  ParamssubjectsSubjectIdUsingGet,
  PageableResultSingleArticleInfo,
  CommonResult,
  CommonResultSubjectVO
} from '@src/services';
import { message } from 'antd';

export interface State {
  loading: boolean;
  articleListModel: PageableResultSingleArticleInfo;
  thematicInfo: SubjectVO;
}

export const thematicModelState: State = {
  loading: false,
  articleListModel: {},

  thematicInfo: { id: 0 }
};

const model = CM({
  state: thematicModelState,
  namespace: 'thematicModel',
  reducers: {
    /** 获取内容时loading */
    updateLoading: (state, action: Tction<{ loading: boolean }>): typeof state => {
      return {
        ...state,
        loading: action.payload.loading
      };
    },
    // 获取文章列表
    setArticleList: (state, action: Tction<PageableResultSingleArticleInfo>) => {
      return {
        ...state,
        articleListModel: action.payload
      };
    },
    // 获取专题详情
    setThematicInfo: (state, action: Tction<{ thematicInfo: SubjectVO }>) => {
      return {
        ...state,
        thematicInfo: action.payload.thematicInfo
      };
    }
  },
  effects: {
    // 获取专题文章列表
    *getArticleList(
      { tPut, tCall },
      action: Tction<{
        params: ParamssubjectsSubjectIdArticlesUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;

      yield tPut(model.actions.updateLoading, {
        loading: true
      });

      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsSubjectIdArticlesUsingGet> = yield tCall(
        APIS.SubjectApi.subjectsSubjectIdArticlesUsingGet,
        params
      );

      yield tPut(model.actions.updateLoading, {
        loading: false
      });

      const { code, result } = res;

      if (code === 0) {
        yield tPut(model.actions.setArticleList, result || {});
      } else {
        message.error(res.message);
      }
    },
    /** 获取专题详情 */
    *getThematicInfo(
      { tPut, tCall },
      action: Tction<{
        params: ParamssubjectsSubjectIdUsingGet;
        callBack?: (res: CommonResultSubjectVO) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.SubjectApi.subjectsSubjectIdUsingGet> = yield tCall(
        APIS.SubjectApi.subjectsSubjectIdUsingGet,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setThematicInfo, { thematicInfo: res.result || { id: 0 } });
        callBack && callBack(res);
      } else {
        message.error(res.message);
      }
    },
    // 收藏切换
    *collection(
      { namespace, put, tPut, tCall },
      action: Tction<{
        articleId: number;
        type: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { articleId, type, callBack } = action.payload;
      let res: CommonResult;
      if (type === true) {
        res = yield tCall(APIS.UserApi.userCollectionArticleIdUsingPost, { articleId });
      } else {
        res = yield tCall(APIS.UserApi.userCollectionArticleIdCancelUsingPost, { articleId });
      }
      if (res.code === 0) {
        message.success(`${type ? '已收藏' : '已取消收藏'}`);
        callBack && callBack();
      }
    }
  }
});

/**
 * @description 全局Model thematicModel 挂载到 redux 上
 */
export default model;
